import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import experience from "../data/jobExpertise.json";

export default function ExperienceSection() {
  return (
    <section id="experience" className="py-16 bg-light dark:bg-dark text-black dark:text-white">
      <div className="max-w-5xl mx-auto px-4">
        <div className="flex items-baseline gap-4 mb-12">
          <span className="font-mono text-[13px] text-accent">02</span>
          <h2 className="text-3xl font-bold tracking-tight">Experience</h2>
          <span className="flex-1 h-px bg-black/10 dark:bg-white/10" />
        </div>

        <div className="relative border-l-4 border-accent ml-6">
          {experience.map((item, index) => (
            <ExperienceCard key={index} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ExperienceCard({ item }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });

  // Dynamically load icon
  let iconSrc;
  try {
    iconSrc = require(`../assets/${item.icon}`);
  } catch {
    iconSrc = null; // fallback if icon doesn't exist
  }

  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, x: -50 }}
      animate={inView ? { opacity: 1, x: 0 } : {}}
      transition={{ duration: 0.6, delay: 0.1 }}
      className="mb-10 ml-6 relative"
    >
      <span className="absolute -left-8 top-2 w-5 h-5 bg-accent rounded-full border-4 border-white dark:border-dark" />

      <div className="bg-white dark:bg-[#121212] p-6 rounded-md shadow-md flex items-start gap-4">
        {iconSrc && (
          <img
            src={iconSrc}
            alt={`${item.title} icon`}
            className="w-10 h-10 object-contain"
          />
        )}
        <div>
          <h3 className="text-xl font-semibold">{item.title}</h3>
          <p className="text-sm text-muted">{item.company}</p>
          <p className="text-sm text-muted mb-2">{item.date}</p>
          <p className="text-sm">{item.description}</p>
        </div>
      </div>
    </motion.div>
  );
}
